
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Hinjewaditomumbaicabs() {



    const cardData =
    {
        keyword: '  Hinjewadi to Mumbai Cabs',
        heading: 'Skyline Cabs:   Hinjewadi to Mumbai Cabs',
        headingDescription: 'Skyline Cabs offers reliable and comfortable Hinjewadi to Mumbai Cabs. Whether you are traveling for business, leisure, or need an airport transfer, our fleet of well-maintained vehicles and professional drivers ensure a smooth and stress-free journey. With timely pickups, competitive fares, and top-notch customer service, Skyline Cabs makes your travel from Hinjewadi to Mumbai comfortable and hassle-free. Book your ride with Skyline Cabs today and enjoy a seamless journey.',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

       "topPlaces": [
    
        {
            "title": "Marine Drive",
            "description": "Known as the Queen’s Necklace, Marine Drive is a 3.6 km long boulevard along the coast of South Mumbai. The stretch is lined with palm trees and offers stunning views of the Arabian Sea, making it an ideal spot for evening strolls, jogging, or simply relaxing by the sea. At night, the streetlights along the curved road resemble a string of pearls, creating a breathtaking visual effect. Marine Drive is also home to some of Mumbai’s finest restaurants, cafes, and luxury hotels, making it a favorite hangout for locals and tourists alike."
        },
        {
            "title": "Elephanta Caves",
            "description": "A UNESCO World Heritage Site, the Elephanta Caves are a group of rock-cut temples located on Elephanta Island, approximately 11 km from Mumbai. These caves date back to the 5th-7th century AD and are primarily dedicated to Lord Shiva. The most famous attraction here is the massive three-headed sculpture of Trimurti, symbolizing the three aspects of Shiva: Creator, Preserver, and Destroyer. The journey to the caves involves a scenic ferry ride from the Gateway of India, making it an adventure-filled and culturally enriching experience."
        },
        {
            "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
            "description": "A magnificent railway station and UNESCO-listed site, CSMT is one of the finest examples of Victorian Gothic Revival architecture in India. Built in 1887 during British rule, this historic structure features a blend of Indian and European design elements, including domes, turrets, stained-glass windows, and intricate carvings. It serves as the headquarters of the Central Railway and is one of the busiest railway stations in India. The illuminated station at night is a sight to behold, attracting architecture and history enthusiasts."
        },
        {
            "title": "Siddhivinayak Temple",
            "description": "One of Mumbai's most revered temples, Siddhivinayak Temple is dedicated to Lord Ganesha and attracts thousands of devotees daily. Built in 1801, the temple is known for its beautiful idol of Ganesha, carved from a single black stone with an elephant trunk tilted to the right. Celebrities, politicians, and common devotees visit the temple to seek blessings. Tuesdays witness a massive crowd of worshippers, as the day is considered auspicious for Lord Ganesha. The temple's serene ambiance offers a spiritual retreat amid Mumbai’s fast-paced life."
        },
        {
            "title": "Juhu Beach",
            "description": "Famous for its vibrant atmosphere, Juhu Beach is one of Mumbai’s most popular attractions. Stretching along the Arabian Sea, it is a hub for locals and tourists seeking relaxation, fun activities, and delicious street food. Visitors can enjoy horse rides, camel rides, and local delicacies like pav bhaji, vada pav, and bhel puri from the numerous food stalls lining the beach. Juhu Beach is also a popular spot for Bollywood celebrity sightings, as many film stars reside in the nearby luxurious localities."
        },
        {
        "title": "Gateway of India",
        "description": "An iconic landmark, the Gateway of India is a must-visit destination in Mumbai. Overlooking the Arabian Sea, this grand arch was built in 1924 to commemorate the visit of King George V and Queen Mary to India. It serves as a historic reminder of the colonial era and is a popular spot for photography, ferry rides to Elephanta Caves, and enjoying the sea breeze. The surrounding area is bustling with street vendors, tourists, and local performers, adding to the vibrant charm of the place."
    },
    {
        "title": "Colaba Causeway",
        "description": "A shopper’s paradise, Colaba Causeway is known for its lively street markets, trendy cafes, and colonial-era architecture. It offers a diverse range of goods, including jewelry, handicrafts, clothing, antiques, and souvenirs at bargain prices. The area is also home to some of Mumbai’s iconic eateries, such as Leopold Café and Café Mondegar, which are must-visit spots for food lovers. The fusion of street shopping, historical charm, and vibrant cafes makes Colaba Causeway an unmissable attraction in Mumbai."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and dargah situated on an islet in the Arabian Sea, Haji Ali Dargah is one of Mumbai’s most significant religious landmarks. Built in the 15th century, it houses the tomb of the Muslim saint Pir Haji Ali Shah Bukhari. The dargah is accessible via a narrow walkway during low tide, offering a unique experience as you walk toward this architectural marvel. It attracts visitors from all faiths, offering a peaceful retreat with mesmerizing views of the sea and skyline."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "An engineering marvel, the Bandra-Worli Sea Link is an eight-lane cable-stayed bridge that connects Bandra to Worli, significantly reducing travel time between the suburbs and South Mumbai. Spanning 5.6 km, it offers breathtaking views of the Mumbai skyline, especially at sunset and night when the bridge is beautifully illuminated. It is a symbol of Mumbai’s modern infrastructure and development, making it a favorite spot for photographers and travelers."
    },
    {
        "title": "Film City",
        "description": "Get a glimpse into Bollywood at Mumbai's famous Film City, officially known as Dadasaheb Phalke Chitranagari. Spread across 520 acres, it features multiple sets, including replicas of villages, urban streets, temples, and even forests, making it a key location for Bollywood films, TV shows, and commercials. Visitors can take guided tours to witness live shoots, explore film sets, and learn about the behind-the-scenes magic of India’s entertainment industry. For movie buffs, this is a dream destination."
    }
],


"services": [
    {
      "name": "Hinjewadi To Borivali Taxi",
      "description": "Skyline Cabs offers reliable taxi service from Hinjewadi to Borivali. Choose from a variety of vehicles, including Innova, Ertiga, or Swift Dzire, for a comfortable and affordable ride."
    },
    {
      "name": "Hinjewadi To Santacruz Taxi",
      "description": "Book your cab from Hinjewadi to Santacruz with Skyline Cabs for a convenient and punctual journey. Whether it's a one-way ride or round trip, we provide top-quality vehicles at competitive rates."
    },
    {
      "name": "Hinjewadi To Andheri Taxi",
      "description": "Skyline Cabs offers a seamless cab service from Hinjewadi to Andheri. Choose from a range of vehicles, including luxury options like Innova Crysta, for a smooth and hassle-free ride."
    },
    {
      "name": "Hinjewadi To Mumbai Airport Taxi",
      "description": "Book a reliable cab from Hinjewadi to Mumbai Airport with Skyline Cabs. Enjoy timely service, comfortable vehicles, and professional drivers for a stress-free airport transfer experience."
    },
    {
      "name": "Hinjewadi To International Airport Cab",
      "description": "Travel to Chhatrapati Shivaji International Airport from Hinjewadi with Skyline Cabs. We offer 24/7 service with premium vehicles such as Innova Crysta and Ertiga for a comfortable ride."
    },
    {
      "name": "Hinjewadi To Airport Fare",
      "description": "Skyline Cabs offers affordable and transparent pricing for Hinjewadi to Mumbai Airport rides. Get an instant quote online and choose your preferred vehicle for the airport transfer."
    },
    {
      "name": "Hinjewadi To Mumbai Drop Taxi Fare",
      "description": "Get a fair and competitive taxi fare for Hinjewadi to Mumbai drop services with Skyline Cabs. Choose from economical options like sedan or premium rides such as Innova and Ertiga."
    },
    {
      "name": "Hinjewadi To Mumbai Central Taxi Fare",
      "description": "Book your cab from Hinjewadi to Mumbai Central with Skyline Cabs for an affordable, comfortable, and reliable ride. We offer fixed pricing with no hidden charges for a transparent experience."
    },
    {
      "name": "Hinjewadi To Goregaon Taxi Fare",
      "description": "Skyline Cabs provides convenient and affordable taxi services from Hinjewadi to Goregaon. Book your cab online or over the phone for easy access to comfortable rides."
    },
    {
      "name": "Hinjewadi To Dadar Cab Service",
      "description": "Skyline Cabs offers direct and punctual taxi service from Hinjewadi to Dadar. Choose from a variety of vehicles, including Innova and Ertiga, for a smooth and comfortable ride."
    },
    {
      "name": "Pune To Mumbai Airport Cab",
      "description": "Skyline Cabs provides reliable and on-time cab service from Pune to Mumbai Airport. Whether it’s a one-way or return trip, enjoy a stress-free journey with our well-maintained vehicles."
    },
    {
      "name": "Pune To Mumbai Ertiga Cab",
      "description": "Book a comfortable Ertiga cab from Pune to Mumbai with Skyline Cabs. The Ertiga offers ample space and comfort for a smooth ride to the airport, hotel, or business meeting."
    },
    {
      "name": "Pune To Mumbai Innova Cab",
      "description": "Travel in luxury and comfort with an Innova cab from Pune to Mumbai. Skyline Cabs offers premium vehicles for a safe and relaxing ride across cities."
    },
    {
      "name": "Hinjewadi To Mumbai Airport Cab Charges",
      "description": "Get the best rates for your Hinjewadi to Mumbai Airport ride with Skyline Cabs. Our fare structure is competitive and transparent, with no hidden costs. Book your cab online and enjoy a smooth ride."
    },
    {
      "name": "Hinjewadi To Andheri Cabs",
      "description": "Skyline Cabs provides reliable cab services from Hinjewadi to Andheri. Whether you're heading for business, shopping, or leisure, we offer comfortable, affordable rides to meet your needs."
    },
    {
      "name": "Hinjewadi To Dadar Cab",
      "description": "Get a direct taxi service from Hinjewadi to Dadar with Skyline Cabs. We offer flexible and affordable ride options with well-maintained cars and experienced drivers."
    },
    {
      "name": "Hinjewadi To Borivali Cabs",
      "description": "Skyline Cabs offers dependable taxi services from Hinjewadi to Borivali. Choose from a range of vehicles, including Innova and Ertiga, for a comfortable and budget-friendly journey."
    },
    {
      "name": "Hinjewadi To Thane Cab Fare",
      "description": "Skyline Cabs provides affordable and transparent taxi services for travel from Hinjewadi to Thane. Enjoy a safe and comfortable ride with professional drivers and a range of vehicles to choose from."
    },
    {
      "name": "Hinjewadi To Virar Cab Fare",
      "description": "Travel from Hinjewadi to Virar with Skyline Cabs at affordable rates. We offer competitive fares and comfortable cars for a pleasant and hassle-free ride."
    },
    {
      "name": "Hinjewadi To Mumbai Ertiga Cab Fare",
      "description": "For affordable, comfortable rides, book an Ertiga cab from Hinjewadi to Mumbai with Skyline Cabs. The Ertiga offers enough space for families and groups, ensuring a comfortable ride."
    },
    {
      "name": "Hinjewadi To Mumbai Innova Cab Fare",
      "description": "Skyline Cabs offers affordable Innova cabs from Hinjewadi to Mumbai. The Innova is perfect for a comfortable and spacious ride, with ample legroom and luggage space."
    },
    {
      "name": "7 Seater Innova On Rent in Pune",
      "description": "Looking to rent a 7-seater Innova in Pune? Skyline Cabs offers Innova rental services for group travel, family vacations, or corporate trips with affordable pricing and high-quality service."
    },
    {
      "name": "Innova Crysta Per Km Rate Pune",
      "description": "Skyline Cabs offers competitive per km rates for Innova Crysta rentals in Pune. Whether for corporate travel or a group outing, we provide flexible rental options to meet your needs."
    },
    {
      "name": "Hinjewadi To Mumbai Skyline Cabs",
      "description": "For a premium and hassle-free travel experience from Hinjewadi to Mumbai, book your cab with Skyline Cabs. We offer a range of vehicles and competitive pricing for your journey."
    },
    {
      "name": "Cab Service in Pune",
      "description": "Skyline Cabs offers a complete cab service in Pune, including intercity rides, airport transfers, and corporate travel. We ensure timely, comfortable, and affordable services for all your travel needs."
    },
    {
      "name": "Pune To Mumbai Cab",
      "description": "Book a reliable and affordable cab from Pune to Mumbai with Skyline Cabs. Our services are available 24/7, with a fleet of cars to suit all your travel preferences."
    },
    {
      "name": "Corporate Cab in Hinjewadi",
      "description": "Skyline Cabs offers premium corporate taxi services in Hinjewadi. Whether it's a business trip or office commute, we provide reliable, punctual, and luxurious cab services to corporate clients."
    }
  ],
  "tableData": [
    ["Hinjewadi To Borivali Taxi", "-Hinjewadi To Santacruz Taxi"],
    ["Hinjewadi To Andheri Taxi", "-Hinjewadi To Mumbai Airport Taxi"],
    ["Hinjewadi To International Airport Cab", "-Hinjewadi To Airport Fare"],
    ["Hinjewadi To Mumbai Drop Taxi Fare", "-Hinjewadi To Mumbai Central Taxi Fare"],
    ["Hinjewadi To Goregaon Taxi Fare", "-Hinjewadi To Dadar Cab Service"],
    ["Pune To Mumbai Airport Cab", "-Pune To Mumbai Ertiga Cab"],
    ["Pune To Mumbai Innova Cab", "-Hinjewadi To Mumbai Airport Cab Charges"],
    ["Hinjewadi To Andheri Cabs", "-Hinjewadi To Dadar Cab"],
    ["Hinjewadi To Borivali Cabs", "-Hinjewadi To Thane Cab Fare"],
    ["Hinjewadi To Virar Cab Fare", "-Hinjewadi To Mumbai Ertiga Cab Fare"],
    ["Hinjewadi To Mumbai Innova Cab Fare", "-7 Seater Innova On Rent in Pune"],
    ["Innova Crysta Per Km Rate Pune", "-Hinjewadi To Mumbai Skyline Cabs"],
    ["Cab Service in Pune", "-Pune To Mumbai Cab"],
    ["Corporate Cab in Hinjewadi", ""]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Hinjewadi to Mumbai Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers dependable and timely cab services from Hinjewadi to Mumbai, perfect for IT professionals, business travelers, and families alike. Whether it’s a planned trip or a last-minute booking, we ensure you're picked up on time and dropped off safely."
    },
    {
        "WhyChooseheading": "Comfortable Rides for Long-Distance Travel",
        "WhyChoosedescription": "Enjoy a relaxing journey from Hinjewadi to Mumbai in our clean, spacious, and well-equipped cabs. Our vehicles come with air-conditioning, plush seats, and extra legroom to make your travel experience smooth and stress-free."
    },
    {
        "WhyChooseheading": "Professional Drivers Familiar with IT Park Schedules",
        "WhyChoosedescription": "Our experienced drivers are punctual, courteous, and well-versed in handling peak-hour traffic around Hinjewadi. They know the best routes to Mumbai and are trained to provide a safe and professional service every time."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
        "WhyChoosedescription": "We offer competitive and transparent fares for Hinjewadi to Mumbai cab services. With Skyline Cabs, you'll always know what you're paying upfront—no hidden charges, no surprises, just honest pricing."
    },
    {
        "WhyChooseheading": "24/7 Cab Availability from Hinjewadi",
        "WhyChoosedescription": "Whether you need a cab early in the morning, late at night, or on short notice, Skyline Cabs is available round-the-clock. We’re always ready to serve professionals, travelers, and families in and around the Hinjewadi area."
    },
    {
        "WhyChooseheading": "Diverse Fleet for Every Travel Style",
        "WhyChoosedescription": "Choose from a wide variety of cabs including hatchbacks, sedans, SUVs, and luxury vehicles based on your travel preference and budget. Our fleet is designed to cater to both individuals and groups traveling from Hinjewadi to Mumbai."
    },
    {
        "WhyChooseheading": "Quick and Easy Online Booking",
        "WhyChoosedescription": "Book your cab in minutes using our user-friendly website or mobile app. Get real-time fare estimates, driver details, and live cab tracking, making your Hinjewadi to Mumbai trip smooth from start to finish."
    },
    {
        "WhyChooseheading": "Safe and Verified Rides Every Time",
        "WhyChoosedescription": "Your safety matters. All Skyline Cabs are GPS-enabled and our drivers are thoroughly background-checked. Whether you're commuting alone or with loved ones, we guarantee a secure and comfortable travel experience."
    }
]









    }


    const faqData = [
        {
            id: 1,
            question: 'How do I book a cab from Hinjewadi to Mumbai with Skyline Cabs?',
            answer:
                'Booking a cab is simple! You can visit our website, download the Skyline Cabs app, or call our customer service. Just input your pickup from Hinjewadi and drop off in Mumbai, choose your vehicle, and confirm your booking.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for Hinjewadi to Mumbai travel?',
            answer:
                'We offer a variety of vehicles including hatchbacks, sedans, SUVs, and luxury cars. Whether you’re traveling alone, with family, or a group, we have the perfect vehicle for your needs.',
        },
        {
            id: 3,
            question: 'Is the fare from Hinjewadi to Mumbai fixed or calculated based on distance?',
            answer:
                'We offer fixed pricing for all intercity trips, including Hinjewadi to Mumbai. Our pricing is transparent, and all tolls, taxes, and extras are shared upfront during booking.',
        },
        {
            id: 4,
            question: 'Can I book a one-way or round-trip cab from Hinjewadi to Mumbai?',
            answer:
                'Yes, you can book both one-way or round-trip cabs. Simply select your travel preference and timing while booking, and we’ll handle the rest.',
        },
        {
            id: 5,
            question: 'How long does the journey from Hinjewadi to Mumbai take?',
            answer:
                'The journey typically takes between 3 to 3.5 hours, depending on traffic conditions. Our experienced drivers ensure a safe and timely arrival.',
        },
        {
            id: 6,
            question: 'Are the drivers experienced and reliable?',
            answer:
                'Yes, all our drivers are thoroughly vetted, experienced in long-distance routes, and trained in safety and customer service, ensuring a comfortable and reliable ride.',
        },
        {
            id: 7,
            question: 'Can I schedule a cab from Hinjewadi to Mumbai in advance?',
            answer:
                'Yes, you can schedule your ride in advance via our website or app. We recommend booking ahead, especially during peak hours or weekends, for the best availability and rates.',
        },
        {
            id: 8,
            question: 'Is airport drop from Hinjewadi to Mumbai available?',
            answer:
                'Yes, we offer direct cab services from Hinjewadi to both Mumbai Domestic and International Airports. Let us know your flight details to ensure timely drop-off.',
        },
        {
            id: 9,
            question: 'Do you offer customer support for online bookings?',
            answer:
                'Yes, our 24/7 customer support team is available to assist with any bookings, trip modifications, or queries related to your Hinjewadi to Mumbai journey.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for my Hinjewadi to Mumbai trip?',
            answer:
                'Skyline Cabs ensures a hassle-free, comfortable, and affordable experience. With experienced drivers, transparent pricing, and well-maintained cars, we provide the best travel experience for your Hinjewadi to Mumbai journey.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Raghav Deshmukh",
            rating: 5,
            review: "The service was fantastic! I booked a cab from Hinjewadi to Mumbai for a business trip. The driver was punctual, the car was clean, and the ride was smooth. I’ll definitely use Skyline Cabs for my next trip!"
        },
        {
            name: "Miss. Aishwarya Verma",
            rating: 4,
            review: "I was happy with the overall experience. The booking process was easy, the driver was friendly, and the car was in great condition. A minor improvement could be better music options, but everything else was spot on!"
        },
    ];
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Hinjewadi to Mumbai Cabs",
  "image": "https://skylinecabs.com/assets/images/hinjewadi-to-mumbai-cabs.jpg",
  "description": "Book Hinjewadi to Mumbai cabs with Skyline Cabs for fast, safe, and affordable travel. Enjoy clean AC sedans or spacious SUVs with verified drivers — available 24/7 for one-way or round-trip rides.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7564"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1350",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/hinjewadi-to-mumbai-cabs"
  }
};



      
      

    return (
        <div>

<Helmet>
  <title>Hinjewadi to Mumbai Cabs | Safe & On-Time Taxi | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Hinjewadi to Mumbai cabs with Skyline Cabs for fast, safe, and affordable travel. Enjoy clean AC sedans or spacious SUVs with verified drivers — available 24/7 for one-way or round-trip rides." 
  />
  <meta 
    name="keywords" 
    content="Hinjewadi to Mumbai Cabs, Cab from Hinjewadi to Mumbai, One-Way Taxi Hinjewadi to Mumbai, Round Trip Cabs Hinjewadi Mumbai, AC Cab Hinjewadi to Mumbai, SUV Taxi Hinjewadi to Mumbai, Online Cab Booking Hinjewadi Mumbai, Skyline Cabs Hinjewadi to Mumbai, Affordable Cabs Hinjewadi to Mumbai, 24/7 Taxi Service Hinjewadi Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/10.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Hinjewaditomumbaicabs;